import { render } from "./LoginPassword.vue?vue&type=template&id=420ced47"
import script from "./LoginPassword.vue?vue&type=script&lang=js"
export * from "./LoginPassword.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__